import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-975ce4ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inner" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "assets/crystal.svg" }),
  /*#__PURE__*/_createElementVNode("img", {
    src: "assets/crystal_spot.png",
    class: "spot"
  })
], -1))
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.element.shown)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "powerup",
        style: _normalizeStyle([
      {
        top: $setup.setPosition.top,
        left: $setup.setPosition.left,
        width: $setup.getWidth(),
      },
    ]),
        "data-type": "timeUp",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.shotPowerup && $setup.shotPowerup(...args)))
      }, _hoisted_2, 4))
    : _createCommentVNode("", true)
}